import { render, staticRenderFns } from "./ofd_unique_customer.vue?vue&type=template&id=601169a3&"
import script from "./ofd_unique_customer.vue?vue&type=script&lang=js&"
export * from "./ofd_unique_customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports